import React from 'react';
import { Box, Button, CircularProgress, Stack, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import { REMINDER_TONE_OPTIONS, type ReminderTone } from './reminderTones';

type Props = {
  tone: ReminderTone;
  onToneChange: (tone: ReminderTone) => void;
  onDraft: (tone: ReminderTone) => void;
  drafting: boolean;
  disabled?: boolean;
};

export function WizzardToneBar({ tone, onToneChange, onDraft, drafting, disabled }: Props) {
  const selected = REMINDER_TONE_OPTIONS.find((t) => t.value === tone);

  const pickTone = (next: ReminderTone) => {
    onToneChange(next);
    onDraft(next);
  };

  return (
    <Box
      sx={{
        p: 1.5,
        borderRadius: 2,
        border: '1px solid',
        borderColor: 'divider',
        bgcolor: 'action.hover',
      }}
    >
      <Stack direction="row" alignItems="center" justifyContent="space-between" flexWrap="wrap" gap={1} sx={{ mb: 1 }}>
        <Typography variant="caption" fontWeight={700} color="text.secondary">
          Wizzard tone
        </Typography>
        <Button
          size="small"
          variant="text"
          startIcon={drafting ? <CircularProgress size={14} /> : <AutoFixHighIcon />}
          disabled={drafting || disabled}
          onClick={() => onDraft(tone)}
        >
          Regenerate
        </Button>
      </Stack>
      <ToggleButtonGroup
        exclusive
        fullWidth
        size="small"
        value={tone}
        onChange={(_, v: ReminderTone | null) => {
          if (v) {
            pickTone(v);
          }
        }}
        disabled={drafting || disabled}
        sx={{ mb: 1 }}
      >
        {REMINDER_TONE_OPTIONS.map((opt) => (
          <ToggleButton key={opt.value} value={opt.value} sx={{ flex: 1, py: 0.75 }}>
            {opt.label}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
      {selected && (
        <Typography variant="caption" color="text.secondary" display="block">
          {selected.description} — uses invoice line items for context (e.g. website hosting → suspension if final).
        </Typography>
      )}
    </Box>
  );
}
